import { render, staticRenderFns } from "./NikoFooter.vue?vue&type=template&id=38d4fc79&"
import script from "./NikoFooter.vue?vue&type=script&lang=js&"
export * from "./NikoFooter.vue?vue&type=script&lang=js&"
import style0 from "./NikoFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports